<template>
  <div class="switch-product" v-if="navs.length > 0">
    <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand" >
      <div class="el-dropdown-link">
        <span class="current-product">{{ currentProductName === '产品中心' ? 'My Unloq' : currentProductName }}</span>
        <!-- <svg-icon iconClass="switch" fill="#2E5A99"></svg-icon> -->
        <img :src="upDownSrc">
      </div>
      <el-dropdown-menu slot="dropdown" class="dropdown-menu">
        <div class="product-items">
          <template v-for="(item, index) in navs">
            <el-dropdown-item :key="index" :command="index">
              <div class="item-contain">
                <span class="menu-title1 menu-item-wrap">
                  {{
                    (item.mapCode === 'MORE10000' && item.name === '产品中心') ? 'My Unloq' : $i18n.locale == 'en' ? item.nameEn : item.name
                  }}
                </span>
                <i v-show="[item.activeTitle,item.name].includes(currentProductName) && index !== navs.length - 1" class="el-icon-check"></i>
              </div>
              
            </el-dropdown-item>
          </template>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import upDownSrc from "@/assets/topBar/upDown.png"

export default {
  props: {
    navs: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      currentProductName: 'My Unloq',
      currentProduct: {},
      isShow: true,
      upDownSrc
    }
  },
  watch: {
    $route: {
      handler(val) {
        if (val.name === 'productCenter' || 
            val.name === 'accountSettingPortal') {
          this.isShow = false
        } else {
          this.isShow = true
        }
      },
      immediate: true
    },
    navs: {
      handler (newVal, oldVal) {
        this.currentProduct = newVal[0]
        let sessionNavs = sessionStorage.getItem('currentProductNavs')
        // 如果产品包括国际结算
        let isIndex = newVal.findIndex(item=>item.mapCode === 'MEUC8006')
        if(isIndex > -1){
          let { name, activeTitle,nameEn, icon } = newVal[isIndex]
          this.currentProductName = this.$i18n.locale === 'en' ? activeTitle : name
          this.currentProduct = newVal[isIndex]
          this.handleCommand(isIndex)
          return
        }
        // 产品中心不展示在标题这里
        if (sessionNavs && JSON.parse(sessionNavs).menuProductType === 'DEFAULT') {
          let { name, activeTitle,nameEn, icon } = newVal[0]
          this.currentProductName = this.$i18n.locale === 'en' ? activeTitle : name
        } else {
          let { name, activeTitle, nameEn, icon } = sessionNavs
            ? JSON.parse(sessionNavs)
            : newVal[0]
          this.currentProductName = this.$i18n.locale === 'en' ? activeTitle : name
        }
      },
      immediate: true
    },
    '$i18n.locale'(newVal) {
      const { name,activeTitle } = this.currentProduct
      this.currentProductName = newVal === 'en' ? activeTitle : name
    },
    currentProduct: {
      deep: true,
      handler(nv) {
        // 产品中心不展示在标题这里
        let sessionNavs = sessionStorage.getItem('currentProductNavs')
        if (JSON.parse(sessionNavs).menuProductType === 'DEFAULT') {
          let { name,activeTitle } = nv
          this.currentProductName = this.$i18n.locale === 'en' ? activeTitle : name
        } else {
          let { name,activeTitle } = sessionNavs ? JSON.parse(sessionNavs) : nv
          this.currentProductName = this.$i18n.locale === 'en' ? activeTitle : name

          if (nv.menuProductType == 'ACCOUNT') {
            //账户系统不需要跳转路由
            this.$emit('gotoAcc')
            return
          }

        }
      },
    },
  },
  methods: {
    handleCommand(index) {
      const currentProduct = this.navs[this.navs[index].mapCode === 'MORE10000' ? 0 : index]
      if (currentProduct.menuCode == 'DTT') { // DTT 类型不需要设置 currentProduct， 因为 name 不需要变动
        // DTT 不需要跳转路由
        this.$emit('gotoDTT')
        return
      }
      this.currentProduct = currentProduct
      if (this.currentProduct.menuProductType == 'ACCOUNT') {
        //账户系统不需要跳转路由
        this.$emit('gotoAcc')
        return
      }
      if(this.navs[index].mapCode === 'MORE10000'){
        this.currentProductName =
          this.$i18n.locale === 'en'
              ? this.navs[0].activeTitle
              : this.navs[0].name
        this.$emit('switchProduct', this.navs[0])
      } else {
        this.currentProductName =
          this.$i18n.locale === 'en'
            ? this.navs[index].activeTitle
            : this.navs[index].name
        this.$emit('switchProduct', this.navs[index])
      }
      
    },
  },
}
</script>

<style lang="scss" scoped>
.switch-product {
  margin-left: 10px;
  cursor: pointer;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  text-align: LEFT;
  color: #2e5a99;
  line-height: 20px;
  padding-right: 18px;

  .el-dropdown-link {
    display: flex;
    align-items: center;

    .current-product {
      margin: 0 9px 0 9px;
      color: #193966;
      font-size: 20px;
      font-weight: 700;
      font-family: 'Open Sans';
    }
  }

  .el-dropdown {
    color: #fff;
  }
}

::v-deep.dropdown-menu {
  max-width: 230px !important;
  .more-product {
    height: 28px;
    margin-top: 8px;
    line-height: 28px;
    color: #2e5a99;
    font-weight: 600;
  }

  .product-items {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    writing-mode: vertical-lr;
    flex-wrap: wrap;
    max-height: unset !important;
    .item-contain {
      width: calc(100% - 40px);
      display: flex;
      justify-content: space-between;
    }
    .el-dropdown-menu__item {
      width: 100%;
      display: flex;
      align-items: center;
      // width: 148px;
      height: 40px;
      writing-mode: horizontal-tb;

      .menu-title1 {
        white-space: nowrap;
        font-size: 14px;
      }
    }
    .el-dropdown-menu__item:nth-last-of-type(1){
      border-top: 1px solid #5A9CF826;
      color: #5A9CF8 !important;
    }
  }
}

</style>
